import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'
import { VpnErrorPage } from './components/VpnErrorPage/VpnErrorPage'
import { useGetFilePool } from './hooks/useGetFilePool'
import { useGetModels } from './hooks/useGetModels'
import { useGetPrompts } from './hooks/useGetPrompts'
import { useWorkingDocumentTelemetry } from './hooks/useWorkingDocumentTelemetry'
import {
  ChatSessionProvider,
  MouseSelectionProvider,
  NotificationProvider,
  SelectedFilesContextProvider,
  WorkingDocumentProvider,
} from './providers'

const AppShell = () => {
  const { t } = useTranslation()
  const { isError: isModelsError } = useGetModels()

  // Preload queries so cache is warm before the user navigates to Files/Prompts
  useGetFilePool()
  useGetPrompts()
  useWorkingDocumentTelemetry()

  if (isModelsError) {
    return <VpnErrorPage />
  }

  return (
    <main>
      <h1 className="sr-only">{t('name')}</h1>
      <WorkingDocumentProvider>
        <MouseSelectionProvider>
          <SelectedFilesContextProvider>
            <NotificationProvider>
              <ChatSessionProvider>
                <Outlet />
              </ChatSessionProvider>
            </NotificationProvider>
          </SelectedFilesContextProvider>
        </MouseSelectionProvider>
      </WorkingDocumentProvider>
    </main>
  )
}

export { AppShell }
